import React, { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { BRAND } from "../theme/colors";

const DISMISS_KEY = "install_prompt_dismissed_at";
const DISMISS_DAYS = 14;

function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as any).standalone === true
  );
}

function wasDismissedRecently() {
  const raw = localStorage.getItem(DISMISS_KEY);
  if (!raw) return false;
  const days = (Date.now() - Number(raw)) / (1000 * 60 * 60 * 24);
  return days < DISMISS_DAYS;
}

function isMobileDevice() {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

const InstallAppPrompt: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isIOS] = useState(() => /iPhone|iPad|iPod/.test(navigator.userAgent));
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isMobileDevice() || isStandalone() || wasDismissedRecently()) return;

    const onBeforeInstall = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);

    // iOS'da beforeinstallprompt umuman kelmaydi — qo'lda ko'rsatma bilan chiqaramiz.
    if (isIOS) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }

    return () =>
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
  }, [isIOS]);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    dismiss();
  };

  if (!visible) return null;

  return (
    <div
      className="fade-up"
      style={{
        position: "fixed",
        left: 12,
        right: 12,
        bottom: 12,
        zIndex: 200,
        maxWidth: 420,
        margin: "0 auto",
        background: "var(--card)",
        border: `1px solid ${BRAND}55`,
        borderRadius: 16,
        padding: "14px 14px",
        boxShadow: "0 12px 40px rgba(0,0,0,.45)",
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
      }}>
      <div
        style={{
          width: 38,
          height: 38,
          borderRadius: 10,
          background: `${BRAND}22`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}>
        {isIOS ?
          <Share size={18} style={{ color: BRAND }} />
        : <Download size={18} style={{ color: BRAND }} />}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ color: "#fff", fontWeight: 800, fontSize: 13 }}>
          Ilovani telefoningizga o'rnating
        </p>
        {isIOS ?
          <p style={{ color: "var(--muted)", fontSize: 11.5, marginTop: 3 }}>
            Pastdagi <strong>Ulashish</strong> (⬆️) tugmasini bosing, keyin{" "}
            <strong>"Bosh ekranga qo'shish"</strong>ni tanlang.
          </p>
        : <>
            <p style={{ color: "var(--muted)", fontSize: 11.5, marginTop: 3 }}>
              Internetsiz ham ishlaydi, tezroq ochiladi.
            </p>
            <button
              onClick={handleInstall}
              style={{
                marginTop: 8,
                background: BRAND,
                color: "#fff",
                fontWeight: 700,
                fontSize: 12,
                padding: "7px 14px",
                borderRadius: 10,
                border: "none",
                cursor: "pointer",
              }}>
              O'rnatish
            </button>
          </>
        }
      </div>

      <button
        onClick={dismiss}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: "var(--muted)",
          padding: 2,
          flexShrink: 0,
        }}>
        <X size={16} />
      </button>
    </div>
  );
};

export default InstallAppPrompt;
